<template>
  <div class="snowfall-day">
    {{ forecastedSnow }}
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SnowFallDay',
  props: ['day'],
  computed: {
    forecastedSnow() {
      if (this.day) {
        return this.snowbaseUnit === 'metric' ? this.forecastedCentimeters : this.forecastedInches;
      }

      return 0;
    },
    forecastedCentimeters() {
      return `${this.day.forecasted_snow_cm} ${this.defaultCMText}`;
    },
    forecastedInches() {
      return `${this.day.forecasted_snow_in} ${this.defaultINText}`;
    },
    ...mapState(['snowbaseUnit', 'defaultCMText', 'defaultINText']),
  },
};
</script>

<style lang="scss" scoped>
  .snowfall-day {
    font-size: 14px;
  }
</style>
